import { Offices_offices } from '@app/appointment/__generated__/Offices';
import { OfficeInfoFragment } from '@app/appointment/__generated__/patient-appointment-inventory-search-graphql.fragments.types';

import { Address } from './address';
import { ServiceArea } from './service-area';

export class Office {
  id: number;
  name: string;
  phone: string | null;
  email: string;
  imageUrl: string;
  address: Address;
  serviceAreaId: number;
  b2bCompanyIds: number[];
  permalink: string | null;
  serviceArea: ServiceArea;

  constructor() {}

  static fromApiV2(officeObject: Record<string, any>): Office {
    const office = new Office();
    office.id = parseInt('' + officeObject.id, 10);
    office.name = officeObject.name;
    office.phone = officeObject.phone;
    office.imageUrl = officeObject.image_url_large;
    office.email = `${officeObject.email_account}@onemedical.com`;
    office.serviceAreaId = officeObject.service_area_id;
    office.b2bCompanyIds = officeObject.b2b_company_ids;
    office.permalink = officeObject.permalink;

    const address = new Address();
    address.address1 = officeObject.address1;
    address.address2 = officeObject.address2;
    address.city = officeObject.city;
    address.state = officeObject.state;
    address.zip = officeObject.zip;
    address.latitude = officeObject.latitude;
    address.longitude = officeObject.longitude;
    office.address = address;

    return office;
  }

  static fromGraphQL(officeObject: Offices_offices): Office {
    const office = new Office();

    office.id = parseInt('' + officeObject.id, 10);
    office.name = officeObject.name;
    office.b2bCompanyIds = officeObject.b2bCompanyIds?.map(idAsString => +idAsString);
    office.serviceArea = ServiceArea.fromGraphQL(officeObject.serviceArea);
    office.email = officeObject.email;
    office.phone = officeObject.phone;

    return office;
  }

  static fromAppointmentSearchGraphQL(graphqlOffice: OfficeInfoFragment): Office {
    const office = new Office();

    office.id = parseInt(graphqlOffice.id, 10);
    office.name = graphqlOffice.name;
    office.permalink = graphqlOffice.permalink;
    office.phone = graphqlOffice.phone;
    office.email = `${graphqlOffice.emailAccount}@onemedical.com`;

    const address = new Address();
    address.address1 = graphqlOffice.address1;
    address.address2 = graphqlOffice.address2;
    address.city = graphqlOffice.city;
    address.state = graphqlOffice.state;
    address.zip = graphqlOffice.zip;
    address.latitude = graphqlOffice.latitude;
    address.longitude = graphqlOffice.longitude;
    office.address = address;

    return office;
  }
}
